// eslint-disable-next-line import/no-cycle
import Apis from '@/Apis/_'
import { CadastroMedicoBackoffice } from '@/types/_'
import ResponseApi from '../interfaces/FactoryResponse'
// eslint-disable-next-line import/no-cycle
import { CoreBase, ICoreBase } from './CoreBase'

class CadastroMedico extends CoreBase implements ICadastroMedico {
  async cadastrarMedicoBackoffice(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cadastrarMedicoBackoffice(params)
    return response
  }

  async sendConvite(param: any): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.sendConvite(param)
    return response
  }

  async deletarConvite(conviteId: string): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.deletarConvite(conviteId)
    return response
  }

  async resendConvite(conviteId: string): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.resendConvite(conviteId)
    return response
  }

  async medicoAssistentesAll(): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.medicoAssistentesAll()
    return response
  }

  async getConvitesAll(hospitais: any): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.getConvitesAll(hospitais)
    return response
  }

  async associarMedicoHospital(params: any): Promise<ResponseApi> {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.associarMedicoHospital(params)
    return request
  }

  async getSecretariaByCpf(params: any): Promise<ResponseApi> {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getSecretariaByCpf(params)
    return request
  }

  async backofficeAlterarMedico(params: any): Promise<ResponseApi> {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAlterarMedico(params)
    return request
  }

  async getBackofficeAssinaturaDoMedico(medicoId: string): Promise<ResponseApi> {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getBackofficeAssinaturaDoMedico(medicoId)
    return request
  }

  async getMedicoDadosPreCadastro(medicoId: string): Promise<ResponseApi> {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getMedicoDadosPreCadastro(medicoId)
    return request
  }

  async getAllCadastrosMedicosByUsuarioHospital(params: any): Promise<ResponseApi> {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllCadastrosMedicosByUsuarioHospital(params)
    return request
  }
}

interface ICadastroMedico extends ICoreBase {
  cadastrarMedicoBackoffice(params: any): Promise<ResponseApi>
  sendConvite(param: any): Promise<ResponseApi>
  resendConvite(conviteId: string): Promise<ResponseApi>
  deletarConvite(conviteId: string): Promise<ResponseApi>
  medicoAssistentesAll(): Promise<ResponseApi>
  getConvitesAll(hospitais: any): Promise<ResponseApi>
  associarMedicoHospital(params: any): Promise<ResponseApi>
  getSecretariaByCpf(params: any): Promise<ResponseApi>
  backofficeAlterarMedico(params: any): Promise<ResponseApi>
  getBackofficeAssinaturaDoMedico(medicoId: string): Promise<ResponseApi>
  getMedicoDadosPreCadastro(medicoId: string): Promise<ResponseApi>
  getAllCadastrosMedicosByUsuarioHospital(params: any): Promise<ResponseApi>
}

export {
  CadastroMedico,
  ICadastroMedico,
}
